export const VNPPI_SET_CONFIGURATIONS = 'VNPPI_SET_CONFIGURATIONS'
export const VNPPI_SET_ORDER_PAYMENTS = 'VNPPI_SET_ORDER_PAYMENTS'